import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';

@Component({  
  templateUrl: './forbidden.component.html'
})
export class ForbiddenComponent implements OnInit {

  constructor() { }  

  ngOnInit(): void {
    setTimeout(() => {
        Swal.close();    
    }, 500);    
  }
}
